import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PropertiesDictionaryModule} from './properties-dictionary/properties-dictionary.module';
import {DeviceLocationModule} from './device-location/device-location.module';
import {RegisteredUsersModule} from './registered-users/registered-users.module';
import {ServersModule} from './servers/servers.module';
import {FileRepositoryModule} from './file-repository/file-repository.module';
import {UserGroupsModule} from './user-groups/user-groups.module';
import {UsersTabModule} from './users-tab/users-tab.module';

@NgModule({
  declarations: [],
  exports: [

  ],
  imports: [
    CommonModule,
    PropertiesDictionaryModule,
    DeviceLocationModule,
    RegisteredUsersModule,
    ServersModule,
    UsersTabModule,
    UserGroupsModule,
    FileRepositoryModule
  ]
})
export class UsersModule { }
